module.exports = __webpack_public_path__ + "media/images/map/payment5-748ec637abd3ed4c104973a3d4ff54cc.svg";